import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { AuditPage } from "@/features/audit/audit-page";
import { baseListSearch, optionalDate, optionalEnum, optionalString } from "@/lib/list-state";

export const Route = createFileRoute("/_authenticated/audit/")({
  validateSearch: z.object({
    ...baseListSearch,
    actor: optionalString,
    actorType: optionalEnum(["ADMIN", "USER", "ROGUE", "SYSTEM"] as const),
    organizationId: optionalString,
    storeId: optionalString,
    action: optionalString,
    resourceType: optionalString,
    resourceId: optionalString,
    result: optionalEnum(["SUCCESS", "FAILURE", "DENIED"] as const),
    from: optionalDate,
    to: optionalDate,
    event: optionalString,
  }),
  head: () => ({ meta: [{ title: "Audit Log · Rogue Admin" }] }),
  component: AuditPage,
});
